
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcTableCell as ObcTableCellElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 
 import {ObcTableHeadCell as ObcTableHeadCellElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 
 import {ObcTableRow as ObcTableRowElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 
 import {ObcTableHeader as ObcTableHeaderElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 
 import {ObcTableBody as ObcTableBodyElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 
 import {ObcTable as ObcTableElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 
 
 

 
 export const ObcTableCell = createComponent({
   react: React,
   tagName: 'obc-table-cell',
   elementClass: ObcTableCellElement,
   events: {
     
   }
  });
 
 export const ObcTableHeadCell = createComponent({
   react: React,
   tagName: 'obc-table-head-cell',
   elementClass: ObcTableHeadCellElement,
   events: {
     
   }
  });
 
 export const ObcTableRow = createComponent({
   react: React,
   tagName: 'obc-table-row',
   elementClass: ObcTableRowElement,
   events: {
     
   }
  });
 
 export const ObcTableHeader = createComponent({
   react: React,
   tagName: 'obc-table-header',
   elementClass: ObcTableHeaderElement,
   events: {
     
   }
  });
 
 export const ObcTableBody = createComponent({
   react: React,
   tagName: 'obc-table-body',
   elementClass: ObcTableBodyElement,
   events: {
     
   }
  });
 
 export const ObcTable = createComponent({
   react: React,
   tagName: 'obc-table',
   elementClass: ObcTableElement,
   events: {
     
   }
  });
 
 